export const companies = [{
  path: '/company',
  name: 'company',
  component: () => import('./Company.vue'),
  meta: {
    rule: 'COMPANIES',
    authRequired: true,
    title: 'general.companies',
    breadcrumb: [
      {
        text: 'general.home',
        disabled: false,
        href: '#/',
      },
      {
        text: 'general.company',
        disabled: true,
        href: '#/company',
      }
    ]
  }
},
{
  path: '/company/edit/:id',
  name: 'editCompany',
  component: () => import('./Form.vue'),
  meta: {
    rule: 'COMPANY_UPDATE',
    authRequired: true,
    title: 'general.company',
    breadcrumb: [
      {
        text: 'general.home',
        disabled: false,
        href: '#/',
      },
      {
        text: 'general.company',
        disabled: false,
        href: '#/company',
      },
      {
        text: 'company.edit',
        disabled: true,
        href: '#/company',
      }
    ]
  }
},
{
  path: '/company/add',
  name: 'newCompany',
  component: () => import('./Form.vue'),
  meta: {
    rule: 'COMPANY_CREATE',
    authRequired: true,
    title: 'general.company',
    breadcrumb: [
      {
        text: 'general.home',
        disabled: false,
        href: '#/',
      },
      {
        text: 'general.company',
        disabled: false,
        href: '#/company',
      },
      {
        text: 'company.add',
        disabled: true,
        href: '#/company',
      }
    ]
  }
}
]
